import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc639ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "header-carousel" }
const _hoisted_3 = { style: {"color":"#292E36"} }
const _hoisted_4 = { class: "d-flex justify-center w-100" }
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-center h-100 margin-not-goals",
  id: "test-advance"
}
const _hoisted_6 = { class: "text-center text-gray-500" }

import { ref } from 'vue';

import { MoleculeCard, MoleculeGoal } from '.';
import { ArrowLeftIcon, ArrowRightIcon } from '@/components/atoms';
import _ from 'lodash'
import { computed } from 'vue';
import { IGoal } from '@/types';
import { carousselLoaded } from '@/store/modules/subBar';
interface IProps {
  items: IGoal[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCarousel',
  props: {
    items: {}
  },
  emits: ['handleLoad'],
  setup(__props: any, { emit: __emit }) {

const showModalGoal = ref<boolean>(false);
const emit = __emit;
const itensFormat = computed(() => {
  props.items.map((item) => {
    if(process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage')
    {
      let aux_goal_name = item.name.split(' - ');
      item.name = process.env.VUE_APP_DEFAULT_GOAL_NAME + ' - ' + aux_goal_name[1];
    }
  });
  return _.chunk(props.items, 3);
})
const props = __props

function handleLoad() {
  emit('handleLoad');
}

function showControllers() {
  return props.items.length > 3;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), { fullHeight: "" }, {
    default: _withCtx(() => [
      (itensFormat.value.length && _unref(carousselLoaded))
        ? (_openBlock(), _createBlock(_component_v_carousel, {
            key: 0,
            hideDelimiterBackground: true,
            "show-arrows": "",
            height: "800px",
            "hide-delimiters": ""
          }, {
            prev: _withCtx(({ props }) => [
              (showControllers())
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "btn-prev-next",
                    onClick: props.onClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, [
                        _createVNode(_unref(ArrowLeftIcon))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            next: _withCtx(({ props }) => [
              (showControllers())
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "btn-prev-next",
                    onClick: props.onClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_unref(ArrowRightIcon))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itensFormat.value, (it, index) => {
                return (_openBlock(), _createBlock(_component_v_carousel_item, {
                  key: String(index)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.$t('message.contributor_summary.active_goals')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.contributor_summary.dont_apply')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: String(idx),
                          class: _normalizeClass(`item-card${(idx == it.length - 1) ? '-no' : ''} ${idx == 0 ? 'v-step-caroussel-item' : ''}`)
                        }, [
                          _createVNode(_unref(MoleculeGoal), {
                            name: item.name,
                            email: item.email,
                            progress: item.progress ?? 0,
                            iconBrand: item.iconBrand,
                            row: item.row,
                            badgeText: item.badgeText,
                            badgeTextColor: item.badgeTextColor,
                            badgeColor: item.badgeColor,
                            style: {"min-width":"286px"},
                            orientation: item.orientation,
                            "is-progress": !!item.progress,
                            goal: item.goal,
                            onHandleLoad: handleLoad
                          }, null, 8, ["name", "email", "progress", "iconBrand", "row", "badgeText", "badgeTextColor", "badgeColor", "orientation", "is-progress", "goal"])
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('message.goals.goal_found')) + " 😔", 1)
          ]))
    ]),
    _: 1
  }))
}
}

})